export const STATUS_CAPTION = {
    issued      : "Awaiting your acknowledgement",
    acknowledged: "Acknowledged · awaiting your approval",
    approved    : "Approved · awaiting settlement",
    rejected    : "Rejected",
    settled     : "Settled",
    reverted    : "Reverted by Nook Ops"
};
